import { render, staticRenderFns } from "./PicturesCollection.vue?vue&type=template&id=78ba9be6&scoped=true"
import script from "./PicturesCollection.vue?vue&type=script&lang=ts"
export * from "./PicturesCollection.vue?vue&type=script&lang=ts"
import style0 from "./PicturesCollection.vue?vue&type=style&index=0&id=78ba9be6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ba9be6",
  null
  
)

export default component.exports